<script setup>
import {reactive, computed, onMounted, onUnmounted, watch, toRaw, ref, nextTick} from 'vue';
import mapboxgl from "mapbox-gl";
import flatPickr from 'vue-flatpickr-component';
import TaskTimedue from "@/Components/Timeline/Subcomponents/TaskTimedue.vue";
import JsonCSV from 'vue-json-csv';
import checklist from './checklist.png';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {ToastUtil} from "@/Utils/ToastUtil";
import {DateUtil} from "@/Utils/DateUtil";
import {Permissions} from "@/Utils/Permissions";
import {VBtn} from "vuetify/components";

const data = reactive({
  taskItems: ['Account Manager Attention Needed', 'Account Manager Review Needed', 'Assign Adjuster', 'Assign Reviewer', 'Complete Inspection', 'Complete Review', 'Holding Per Client','Make Contact','Make Corrections','Meet and Greet', 'Recontact', 'Review Corrections', 'Review Manager Attention Needed', 'Submit For Review','Submit To Client / Close Claim', 'No Task'],
  adjustercatactive: '',
  adjusterfirstcall: '',
  adjusterfirstname: '',
  personname: '',
  clientcontactname:'',
  reviewername: '',
  writername: '',
  adjusterpref: '',
  catcode: '',
  claimantname: '',
  geodata: [],
  date: null,
  claimnumber: '',
  claims: [],
  headers: [],
  snackbar: false,
  messageSelections: [],
  messageDialog: false,
  dialogData: [],
  messageBody: '',
  config: {
    flatpickr: {
      inline: true,
      enableTime: true,
      minuteIncrement: 15,
      minDate: new Date(),
      allowInput: false,
      disableMobile: true,
    }
  },
  showTaskUpdateAllSelections: false,
  showTaskUpdateOneSelection: false,
  taskUpdateOneSelection: [],
  taskUpdateAllSelections: [],
  newTimeDue: new Date(),
  popupHeaders: [
    {
      title: 'Claim Number',
      key: 'claimnumber',
      bool: true,
    },
    {
      title: 'Policy Number',
      align: 'start',
      key: 'policynumber',
      bool: true,
    },
    {
      title: 'Client',
      key: 'name',
      bool: true,
    },
    {
      title: 'Adjuster',
      key: 'adjuster',
      bool: true,
    },
    {
      title: 'Writer',
      key: 'writer',
      bool: true,
    },
    {
      title: 'Insured',
      key: 'insured',
      bool: true,
    },
    {
      title: 'Insured Phone',
      key: 'insuredphone',
      bool: false,
    },
    {
      title: 'Cat. Code',
      key: 'catcode',
      bool: false,
    },
    {
      title: 'Type',
      key: 'type',
      bool: false,
    },
    {
      title: 'Date Started',
      key: 'datestarted',
      bool: true,
    },
    {
      title: 'Original Date Closed',
      key: 'originaldateclosed',
      bool: true,
    },
    {
      title: 'Date Closed',
      key: 'dateclosed',
      bool: true,
    },
    {
      title: 'Loss Date',
      key: 'lossdate',
      bool: true,
    },
    {
      title: 'Age',
      key: 'age',
      bool: true,
    },
    {
      title: 'Loss Amount',
      key: 'lossamount',
      bool: false,
    },
    {
      title: 'Account Manager',
      key: 'acctmgr',
      bool: true,
    },
    {
      title: 'Reviewer',
      key: 'reviewer',
      bool: true,
    },
    {
      title: 'Current Task',
      key: 'curtask',
      bool: true,
    },
    {
      title: 'Appointment',
      key: 'appointment',
      bool: true,
    },
  ],
  claimStatus: ['Open', 'Closed'],
  claimtype: '',
  client: null,
  clients: [],
  closedenddate: '',
  closedstartdate: '',
  originalclosedenddate: '',
  originalclosedstartdate: '',
  receivedenddate: '',
  receiveddstartdate: '',
  clustering: false,
  currentstatus: '',
  dataLoading: false,
  enddate: '',
  endDate: null,
  estimatedloss: '',
  estimatedlosscompare: '',
  filterArr: [],
  firstLoad: true,
  insurancecompany: '',
  insuredlastname: '',
  insuredstreet: '',
  lossstreet: '',
  internalclaimnumber: '',
  policynumber: '',
  isclosed: 'Open',
  items: [],
  mapCurrentPoint: {},
  mapCurrentPointFeatures: {},
  labels: {
    claimnumber: "Claim Number",
    city: "City",
    state: "State",
    zip: "Zip Code",
    age: "Age",
    type: "Type",
    lossamount: "Loss Amount",
    catcode: "Cat Code",
    lossdate: "Loss Date",
    datereceived: "Date Received",
    claimstatus: "Claim Status",
    clientcontact: "Client Contact",
    adjuster: "Adjuster",
    adjusternpn: "Adjuster NPN",
    adjustercell: "Adjuster Cell",
    adjusteremail: "Adjuster Email",
    writer: "Writer",
    writercell: "Writer Cell",
    writeremail: "Writer Email",
    insured: "Insured",
    insuredphone: "Insured Phone #",
    acctmgr: "Account Manager",
    reviewer: "Reviewer",
    norole: "No Role",
    tasknames: "Task Names",
    taskexpire: "Task Expiry",
    name: "Client",
    recentcomplete: "Recent Complete",
    recentcompletetime: "Recent Complete Time",
    datecontacted: "Date Contacted",
    inspectionscheduled: "Inspection Scheduled",
    inspectioncompleted: "Inspection Completed",
    reviewcompleted: "Review Completed",
    originaldateclosed: "Original Date Closed",
    dateclosed: "Date Closed",
    policynumber: "Policy Number",
    id: "ID",
    status: "Status",
    additionalinfo: "Additional Info",
    streetaddress: "Street Address",
    latitude: "Latitude",
    longitude: "Longitude",
    isclosed: "Is Closed",
    adminfee: "Admin Fee",
    review_priority: "Review Priority",
    xact_id: "Xact ID",
    datestartedformat: "Date Started",
    clientid: "Client ID",
    ida: "IDa",
    adjusterpref: "Adjuster Preference",
    firstcall: "First Call",
    catactive: "Cat Active",
    datestarted: "Date Started",
    datecompleted: "Date Completed"
  },
  loading: false,
  lossenddate: '',
  lossMaxModel: null,
  lossMinModel: null,
  lossstartdate: '',
  map: null,
  mapMarkers: [],
  menu1: false,
  menu2: false,
  menu3: false,
  menu4: false,
  menu5: false,
  menu6: false,
  menu7: false,
  menu8: false,
  menu9: false,
  menu10: false,
  newUrl: '',
  offset1: true,
  offset2: true,
  offset3: true,
  offset4: true,
  offset5: true,
  offset6: true,
  offset7: true,
  offset8: true,
  offset9: true,
  offset10: true,
  openclosedstatus: 'Open',
  options: {
    sortBy: [{key: '', order: 'desc'}],
    page: 1,
    itemsPerPage: 1000
  },
  prevOptions: {},
  pendingItems: ['True', 'False'],
  pendingModel: null,
  prevSortBy: 'name', // default value from datatable
  prevSortDir: false, // default value from datatable
  search: '',
  searchRefresh: '',
  searchRequest: null,
  showMap: false,
  startdate: '',
  startDate: null,
  state: '',
  stateItems: [ 'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY' ],
  stateModel: null,
  statustimeremaining: '',
  totalClaims: 0,
  timezone: new Date(),
  unsortedClaimsCopy: null,
  defaultHeaders: [
    {
      title: 'Claim Number',
      align: 'start',
      key: 'claimnumber',
      bool: true,
    },
    {
      title: 'Policy Number',
      align: 'start',
      key: 'policynumber',
      bool: true,
    },
    {
      title: 'Street Address',
      key: 'streetaddress',
      bool: true,
    },
    {
      title: 'City',
      key: 'city',
      bool: true,
    },
    {
      title: 'State',
      key: 'state',
      bool: true,
    },
    {
      title: 'Zip',
      key: 'zip',
      bool: true,
    },
    {
      title: 'Age(Days)',
      key: 'age',
      bool: true,
    },
    {
      title: 'Type',
      key: 'type',
      bool: true,
    },
    { title: 'Loss Amount',
      align: ' d-none',
      key: 'lossamount',
      bool: false
    },
    {
      title: 'Cat Code',
      key: 'catcode',
      bool: true,
    },
    {
      title: 'Loss Date',
      key: 'lossdate',
      bool: true,
    },
    {
      title: 'Date Received',
      key: 'datereceived',
      bool: true,
    },
    {
      title: 'Claim Status',
      key: 'isclosed',
      bool: true,
    },
    {
      title: 'Client Contact',
      key: 'clientcontact',
      bool: true,
    },
    {
      title: 'Adjuster',
      key: 'adjuster',
      bool: true,
    },
    {
      title: 'Adjuster NPN',
      key: 'adjusternpn',
      bool: true,
    },
    {
      title: 'Adjuster Cell',
      key: 'adjustercell',
      bool: true,
    },
    {
      title: 'Adjuster Email',
      key: 'adjusteremail',
      bool: true,
    },
    {
      title: 'Writer',
      key: 'writer',
      bool: true,
    },
    {
      title: 'Writer Cell',
      key: 'writercell',
      bool: true,
    },
    {
      title: 'Writer Email',
      key: 'writeremail',
      bool: true,
    },
    {
      title: 'Insured',
      key: 'insured',
      bool: true,
    },
    {
      title: 'Insured Phone',
      key: 'insuredphone',
      bool: true,
    },
    {
      title: 'Acct Managers',
      key: 'acctmgr',
      bool: false,
      sortable: true,
    },
    {
      title: 'Reviewers',
      key: 'reviewer',
      bool: false,
      sortable: true,
    },
    {
      title: 'Review Team Managers',
      key: 'rtm',
      bool: false,
      sortable: true,
    },
    {
      title: 'No Role',
      key: 'norole',
      bool: false,
      sortable: true,
    },
    {
      title: 'In Task',
      key: 'tasknames',
      bool: true,
    },
    {
      title: 'Task Expire Date',
      key: 'taskexpire',
      bool: true,
    },
    {
      title: 'Client',
      key: 'name',
      bool: true,
    },
    {
      title: 'Recent Completed Task',
      key: 'recentcomplete',
      bool: true,
    },
    {
      title: 'Recent Completed Task Time',
      key: 'recentcompletetime',
      bool: true,
    },
    {
      title: 'Date Contacted',
      key: 'datecontacted',
      bool: true,
    },
    {
      title: 'Date Inspection Scheduled',
      key: 'inspectionscheduled',
      bool: true,
    },
    {
      title: 'Date Appointment Set',
      key: 'apptset',
      bool: true,
    },
    {
      title: 'Date Inspection Completed',
      key: 'inspectioncompleted',
      bool: true,
    },
    {
      title: 'Date Reviewer Assigned',
      key: 'datereviewerassigned',
      bool: true,
    },
    {
      title: 'Date Review Completed',
      key: 'reviewcompleted',
      bool: true,
    },
    {
      title: 'Original Date Closed',
      key: 'originaldateclosed',
      bool: true,
    },
    {
      title: 'Date Closed',
      key: 'dateclosed',
      bool: true,
    },
  ],

  menuItems: [
    {
      title: 'State',
      items: null,
      filterActive: false,
    },
    {
      title: 'Loss Amount',
      items: [
        {
          title: 'Max Loss',
          filterActive: false,
        },
        {
          title: 'Min Loss',
          filterActive: false,
        },
      ],
    },
    {
      title: 'Client',
      items: null,
      filterActive: false,
    },
    {
      title: 'Open/Closed',
      items: null,
      filterActive: false,
    },
    {
      title: 'Date Created',
      filterActive: false,
    },
  ],
});

const csvData = computed(() => {
  // CSV File
  return data.items.map((item) => ({
    claims: item.claimnumber,
    lossamount: item.lossamount,
    state: item.state,
    tasknames: item.tasknames,
    people: item.people,
    client: item.name
  }))
});

const headers = computed(() => {
  return [
    {
      title: 'Claim Number',
      align: 'start',
      key: 'claimnumber',
      bool: true,
    },
    {
      title: 'Policy Number',
      align: 'start',
      key: 'policynumber',
      bool: true,
    },
    {
      title: 'Street Address',
      key: 'streetaddress',
      bool: true,
    },
    {
      title: 'City',
      key: 'city',
      bool: true,
    },
    {
      title: 'State',
      key: 'state',
      bool: true,
    },
    {
      title: 'Zip',
      key: 'zip',
      bool: true,
    },
    {
      title: 'Age(Days)',
      key: 'age',
      bool: true,
    },
    {
      title: 'Type',
      key: 'type',
      bool: true,
    },
    { title: 'Loss Amount', align: ' d-none' ,key: 'lossamount', bool: false },
    {
      title: 'Cat Code',
      key: 'catcode',
      bool: true,
    },
    {
      title: 'Loss Date',
      key: 'lossdate',
      bool: true,
    },
    {
      title: 'Date Received',
      key: 'datereceived',
      bool: true,
    },
    {
      title: 'Claim Status',
      key: 'isclosed',
      bool: true,
    },
    {
      title: 'Client Contact',
      key: 'clientcontact',
      bool: true,
    },
    {
      title: 'Adjuster',
      key: 'adjuster',
      bool: true,
    },
    {
      title: 'Adjuster NPN',
      key: 'adjusternpn',
      bool: true,
    },
    {
      title: 'Adjuster Cell',
      key: 'adjustercell',
      bool: true,
    },
    {
      title: 'Adjuster Email',
      key: 'adjusteremail',
      bool: true,
    },
    {
      title: 'Writer',
      key: 'writer',
      bool: true,
    },
    {
      title: 'Writer Cell',
      key: 'writercell',
      bool: true,
    },
    {
      title: 'Writer Email',
      key: 'writeremail',
      bool: true,
    },
    {
      title: 'Insured',
      key: 'insured',
      bool: true,
    },
    {
      title: 'Insured Phone',
      key: 'insuredphone',
      bool: true,
    },
    {
      title: 'Acct Managers',
      key: 'acctmgr',
      bool: false,
      sortable: true,
    },{
      title: 'Reviewers',
      key: 'reviewer',
      bool: false,
      sortable: true,
    },
    {
      title: 'Review Team Managers',
      key: 'rtm',
      bool: false,
      sortable: true,
    },
    {
      title: 'No Role',
      key: 'norole',
      bool: false,
      sortable: true,
    },
    {
      title: 'In Task',
      key: 'tasknames',
      bool: true,
    },
    {
      title: 'Task Expire Date',
      key: 'taskexpire',
      bool: true,
    },
    {
      title: 'Client',
      key: 'name',
      bool: true,
    },
    {
      title: 'Recent Completed Task',
      key: 'recentcomplete',
      bool: true,
    },
    {
      title: 'Recent Completed Task Time',
      key: 'recentcompletetime',
      bool: true,
    },
    {
      title: 'Date Contacted',
      key: 'datecontacted',
      bool: true,
    },
    {
      title: 'Date Inspection Scheduled',
      key: 'inspectionscheduled',
      bool: true,
    },
    {
      title: 'Date Appointment Set',
      key: 'apptset',
      bool: true,
    },
    {
      title: 'Date Inspection Completed',
      key: 'inspectioncompleted',
      bool: true,
    },
    {
      title: 'Date Reviewer Assigned',
      key: 'datereviewerassigned',
      bool: true,
    },
    {
      title: 'Date Review Completed',
      key: 'reviewcompleted',
      bool: true,
    },
    {
      title: 'Original Date Closed',
      key: 'originaldateclosed',
      bool: true,
    },
    {
      title: 'Date Closed',
      key: 'dateclosed',
      bool: true,
    },
  ]
});

const getHeaderFields = () => {
  let headerArr = []
  for(let x in data.headers){
    if(data.headers[x].align !== ' d-none'){
      headerArr.push(data.headers[x].key)
    }
  }
  return headerArr
}

const getTimezone = (timezoneShortened) => {
  const tzName = data.timezone
  return tzName.toLocaleString('en', {timeZoneName:'short'}).split(' ').pop();
}

const searchBtnRef = ref(null);

const refresh = ({page, itemsPerPage, sortBy, nomap}) => {
  data.dataLoading = true
  if(data.estimatedlosscompare === null){
    data.estimatedlosscompare = ''
  }
  if(data.state === null){
    data.state = ''
  }
  if(data.claimtype === null){
    data.claimtype = ''
  }
  if(data.openclosedstatus === null){
    data.openclosedstatus = ''
  }
  if(data.currentstatus === null){
    data.currentstatus = ''
  }
  if(data.claimnumber === null){
    data.claimnumber = ''
  }
  if(data.insuredlastname === null){
    data.insuredlastname = ''
  }
  if(data.internalclaimnumber === null){
    data.internalclaimnumber = ''
  }
  if(data.policynumber === null) {
    data.policynumber = ''
  }
  if(data.insuredstreet === null){
    data.insuredstreet = ''
  }
  if(data.lossstreet === null){
    data.lossstreet = ''
  }
  if(data.claimantname === null){
    data.claimantname = ''
  }
  if(data.personname === null){
    data.personname = ''
  }
  if(data.clientcontactname === null){
    data.clientcontactname = ''
  }
  if(data.reviewername === null){
    data.reviewername = ''
  }
  if(data.adjusterfirstname === null){
    data.adjusterfirstname = ''
  }
  if(data.adjusterfirstcall === null){
    data.adjusterfirstcall = ''
  }
  if(data.adjusterpref === null){
    data.adjusterpref = ''
  }
  if(data.adjustercatactive === null){
    data.adjustercatactive = ''
  }
  if(data.statustimeremaining === null){
    data.statustimeremaining = ''
  }
  if(data.catcode === null){
    data.catcode = ''
  }
  if(data.startdate === null){
    data.startdate = ''
  }
  if(data.enddate === null){
    data.enddate = ''
  }
  if(data.lossstartdate === null){
    data.lossstartdate = ''
  }
  if(data.lossenddate === null){
    data.lossenddate = ''
  }
  if(data.closedstartdate === null){
    data.closedstartdate = ''
  }
  if(data.closedenddate === null){
    data.closedenddate = ''
  }
  if(data.originalclosedstartdate === null){
    data.originalclosedstartdate = ''
  }
  if(data.originalclosedenddate === null){
    data.originalclosedenddate = ''
  }
  if(data.receivedstartdate === null){
    data.receivedstartdate = ''
  }
  if(data.receivedenddate === null){
    data.receivedenddate = ''
  }
  if(data.estimatedloss === null){
    data.estimatedloss = ''
  }
  if(data.search === null){
    data.search = ''
  }
  if(data.insurancecompany === null){
    data.insurancecompany = ''
  }

  if(sortBy?.length > 0){
    data.prevSortBy = sortBy.length > 0 ? sortBy[0].key : data.prevSortBy;
    data.prevSortDir = sortBy.length > 0 ? sortBy[0].order : data.prevSortDir;
  }else{
    data.prevSortBy = null
    data.prevSortDir = null
  }

  ApiWrapper.post('claims', 'filter-claims', {
        claimnumber: data.claimnumber,
        insuredlastname: data.insuredlastname,
        internalclaimnumber: data.internalclaimnumber,
        policynumber: data.policynumber,
        insuredstreet: data.insuredstreet,
        lossstreet: data.lossstreet,
        claimantname: data.claimantname,
        reviewername: data.reviewername,
        writername: data.writername,
        personname: data.personname,
        clientcontactname: data.clientcontactname,
        adjusterfirstcall: data.adjusterfirstcall,
        adjusterpref: data.adjusterpref,
        adjustercatactive: data.adjustercatactive,
        statustimeremaining: data.statustimeremaining,
        adjusterfirstname: data.adjusterfirstname,
        adjusternpn: data.adjusternpn,
        catcode: data.catcode,
        insurancecompany: data.insurancecompany,
        startdate: data.startdate,
        enddate: data.enddate,
        currentstatus: data.currentstatus,
        lossstartdate: data.lossstartdate,
        lossenddate: data.lossenddate,
        openclosedstatus: data.openclosedstatus,
        claimtype: data.claimtype,
        closedstartdate: data.closedstartdate,
        closedenddate: data.closedenddate,
        originalclosedstartdate: data.originalclosedstartdate,
        originalclosedenddate: data.originalclosedenddate,
        receivedstartdate: data.receivedstartdate,
        receivedenddate: data.receivedenddate,
        state: data.state,
        estimatedlosscompare: data.estimatedlosscompare,
        estimatedloss: data.estimatedloss,
        itemsPerPage: itemsPerPage,
        sortBy: sortBy?.length > 0 ? sortBy[0].key : '',
        sortDesc: sortBy?.length > 0 ? sortBy[0].order : 'desc',
        page: page,
      })
      .then((response) => {
        let claims = response.data;

        for(let i=0; i < claims.length; i++) {
          claims[i]['row_number'] = i
        }

        claims.forEach(function (arrayItem) {
          if(arrayItem.isclosed !== null && arrayItem.isclosed !== undefined){
            if(arrayItem.isclosed === true){
              arrayItem.claimstatus = 'Closed'
            }else if (arrayItem.isclosed === false){
              arrayItem.claimstatus = 'Open'
            }
          }
        });

        data.claims = claims;
        data.items = claims;
        // save copy for unsorting when data doesn't get reloaded
        data.unsortedClaimsCopy = claims;

        let total = response.total;
        data.geodata = response.geodata;
        data.totalClaims = (total * 1);

        if(nomap !== true) {
          clearMapPopups();
          createMapMarkers(response.geodata, 'claim');
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.prevOptions.page = page;
        data.prevOptions.itemsPerPage = itemsPerPage;
        data.prevOptions.sortBy = sortBy ? JSON.parse(JSON.stringify(sortBy)) : sortBy;
        data.loading = false;
        data.dataLoading = false;
        nextTick(()=>{
          if(searchBtnRef.value?.$el){
            searchBtnRef.value.$el.focus()
          }
        })
      });
}

const getClients = () => {
  ApiWrapper.post('claims', 'get-clients', {})
      .then((response) => {
        data.clients = response.clients.map(function (obj) {
          return obj.name
        })
        data.clients.sort()
        changeHeaders()
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false;
        data.dataLoading = false;
      })
}

const hideMap = (bool) => {
  if(!bool){
    document.getElementById('map').style.visibility = 'hidden';
    document.getElementById('map').style.height = '0px';

  }else{
    document.getElementById('map').style.visibility = 'visible';
    document.getElementById('map').style.height = '500px';

  }


}

const changeHeaders = () => {
  data.headers = headers.value;

  for (let x in data.defaultHeaders) {
    if (data.defaultHeaders[x].bool === false) {
      if(data.headers[x]){
        data.headers[x].align = ' d-none'
      }
    } else {
      if(data.headers[x]){
        data.headers[x].align = ''
      }
    }
  }

  localStorage.setItem('headers', JSON.stringify(data.defaultHeaders))
  localStorage.setItem('version', 5)



  data.searchRefresh = ' '
  setTimeout(() => {
    data.searchRefresh = ''
  }, 10)
}

const searchMap = () => {
  let encodedSearch = encodeURI(data.searchRequest.replace('#', ''))
  let map = data.map
  ApiWrapper.getRaw('https://api.mapbox.com/geocoding/v5/mapbox.places/' +
        encodedSearch +
        '.json?access_token=pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'
  )
  .then(function (response) {
    map.flyTo({
      center: response.features[0].center,
      zoom: 9,
      essential: true, // this animation is considered essential with respect to prefers-reduced-motion
    })
  })
  .catch((err) => {
    ToastUtil.error(err);
  })
}

const getData = () => {
  getClients()
}

const getUnique = (arr, value) => {
  let finalArr = []
  let flatArr = arr.map(function (obj) {
    return obj[value]
  })

  for (let x in flatArr) {
    if (finalArr.indexOf(flatArr[x]) === -1) {
      finalArr.push(flatArr[x])
    }
  }
  return finalArr
}

// csvExport(arrData) {
//   // CSV File
//   let csvContent = 'data:text/csv;charset=utf-8,'
//   csvContent += [
//     Object.keys(arrData[0]).join(';'),
//     ...arrData.map((item) => Object.values(item).join(';')),
//   ]
//     .join('\n')
//     .replace(/(^\[)|(\]$)/gm, '')

//   const data = encodeURI(csvContent)
//   const link = document.createElement('a')
//   link.setAttribute('href', data)
//   link.setAttribute('download', 'export.csv')
//   link.click()
// },

const createMapMarkers = (geodata, type) => {
  localStorage.setItem('headersClaimMap', JSON.stringify(data.popupHeaders))
  localStorage.setItem('versionClaimMap', 2)

  if (data.firstLoad === false) {
    data.map.removeLayer('clusters')
    data.map.removeLayer('cluster-count')
    data.map.removeLayer('unclustered-point')
    data.map.removeSource('notype')
  } else {
    data.firstLoad = false
  }

  data.map.addSource('notype', {
    type: 'geojson',
    // // Point to GeoJSON data. This example visualizes all M1.0+ earthquakes
    // // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
    data: geodata,
    cluster: data.clustering,
    clusterMaxZoom: 14, // Max zoom to cluster points on
    clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
  })

  data.map.addLayer({
    id: 'clusters',
    type: 'circle',
    source: 'notype',
    filter: ['has', 'point_count'],
    paint: {
      // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
      // with three steps to implement three types of circles:
      //   * Blue, 20px circles when point count is less than 100
      //   * Yellow, 30px circles when point count is between 100 and 750
      //   * Pink, 40px circles when point count is greater than or equal to 750
      'circle-color': [
        'step',
        ['get', 'point_count'],
        '#51bbd6',
        100,
        '#f1f075',
        750,
        '#f28cb1',
      ],
      'circle-radius': [
        'step',
        ['get', 'point_count'],
        20,
        100,
        30,
        750,
        40,
      ],
    },
  })

  data.map.addLayer({
    id: 'cluster-count',
    type: 'symbol',
    source: 'notype',
    filter: ['has', 'point_count'],
    layout: {
      'text-field': '{point_count_abbreviated}',
      'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
      'text-size': 12,
    },
  })

  data.map.addLayer({
    id: 'unclustered-point',
    source: 'notype',
    type: 'symbol',
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': 'claim',
      'icon-size': 0.10,
      'icon-allow-overlap': true,
    },
  })

  // inspect a cluster on click
  data.map.on('click', 'clusters', function (e) {
    let features = data.map.queryRenderedFeatures(e.point, {
      layers: ['clusters'],
    })
    let clusterId = features[0].properties.cluster_id
    data.map
        .getSource('notype')
        .getClusterExpansionZoom(clusterId, function (err, zoom) {
          if (err) return

          data.map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom,
          })
        })
  })

  // When a click event occurs on a feature in
  // the unclustered-point layer, open a popup at
  // the location of the feature, with
  // description HTML from its properties.
  data.map.on('click', 'unclustered-point', function (e) {
    mapCreateUnclusteredPointPopup(e);
  })

  data.map.on('mouseenter', 'clusters', function () {
    data.map.getCanvas().style.cursor = 'pointer'
  })
  data.map.on('mouseleave', 'clusters', function () {
    data.map.getCanvas().style.cursor = ''
  })

  data.loading = false
}

const mapCreateUnclusteredPointPopup = (pointObj = {}) => {
  let storedPointObj = toRaw(data.mapCurrentPoint);
  let passedPoint = Object.keys(pointObj).length > 0;
  let storedPoint = Object.keys(storedPointObj).length > 0;
  //if we have data in either the passed in map point or the stored point, proceed
  if(passedPoint || storedPoint){
    //no map point passed in, use the stored point
    if(!passedPoint && storedPoint){
      pointObj = storedPointObj
      //add stored features to object due to deep copy issues with main obj.
      pointObj.features = toRaw(data.mapCurrentPointFeatures);
    }
    //if a new map point is passed in, store it
    if(passedPoint && !storedPoint){
      data.mapCurrentPoint = pointObj;
      //store features separately due to deep copy issues with main obj.
      data.mapCurrentPointFeatures = pointObj.features;
    }

    //Now proceed with creating and displaying the map point
    clearMapPopups();
    let stackedClaims = []
    for (let x in pointObj.features) {
      let clientname =
          pointObj.features[x].properties.client !== 'null'
              ? pointObj.features[x].properties.client
              : 'Unassigned'


      let adjuster =
          pointObj.features[x].properties.adjuster !== 'null'
              ? pointObj.features[x].properties.adjuster
              : 'Unassigned'

      let writer =
          pointObj.features[x].properties.writer !== 'null'
              ? pointObj.features[x].properties.writer
              : 'Unassigned'

      let newClaim = {
        claimnumber: pointObj.features[x].properties.claimnumber,
        name: clientname,
        id: pointObj.features[x].properties.id,
        adjuster: adjuster,
        adjusterid: pointObj.features[x].properties.adjusterid,
        writer: writer,
        writerid: pointObj.features[x].properties.writerid,
        insured:  pointObj.features[x].properties.insured,
        insuredphone:  pointObj.features[x].properties.insuredphone,
        policynumber:  pointObj.features[x].properties.policynumber,
        type:  pointObj.features[x].properties.type,
        datestarted:  new Date(pointObj.features[x].properties.datestarted).toLocaleDateString('en-US') !== 'Invalid Date' ? new Date(pointObj.features[x].properties.datestarted).toLocaleDateString('en-US') : '',
        datecompleted:  new Date(pointObj.features[x].properties.datecompleted).toLocaleDateString('en-US') !== 'Invalid Date' ? new Date(pointObj.features[x].properties.datecompleted).toLocaleDateString('en-US') : '',
        lossamount:  pointObj.features[x].properties.lossamount,
        catcode:  pointObj.features[x].properties.catcode,
        lossdate:  new Date(pointObj.features[x].properties.lossdate).toLocaleDateString('en-US') !== 'Invalid Date' ? new Date(pointObj.features[x].properties.lossdate).toLocaleDateString('en-US') : '',
        age:  pointObj.features[x].properties.age,
        dateclosed: new Date(pointObj.features[x].properties.dateclosed).toLocaleDateString('en-US') !== 'Invalid Date' ? new Date(pointObj.features[x].properties.dateclosed).toLocaleDateString('en-US') : '',
        originaldateclosed: new Date(pointObj.features[x].properties.originaldateclosed).toLocaleDateString('en-US') !== 'Invalid Date' ? new Date(pointObj.features[x].properties.originaldateclosed).toLocaleDateString('en-US') : '',
        acctmgr:  pointObj.features[x].properties.acctmgr,
        reviewer:  pointObj.features[x].properties.reviewer,
        curtask:  pointObj.features[x].properties.tasknames,
        appointment:new Date( pointObj.features[x].properties.apptset).toLocaleDateString('en-US')  !== 'Invalid Date' ? new Date( pointObj.features[x].properties.apptset).toLocaleDateString('en-US') : ''
      }
      stackedClaims.push(newClaim)
    }

    let coordinates = pointObj.features[0].geometry.coordinates.slice()

    // Ensure that if thedata.map is zoomed out such that
    // multiple copies of the feature are visible, the
    // popup appears over the copy being pointed to.
    while (Math.abs(pointObj.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += pointObj.lngLat.lng > coordinates[0] ? 360 : -360
    }


    let htmlString = ''
    for (let y = 0; y < stackedClaims.length; y++) {
      if (stackedClaims.length > 1) {
        htmlString += `<div style="border-bottom: 1px solid black;width: 400px;height:100%">`
      } else {
        htmlString += `<div style="width: 400px;height:100%">`
      }

      let col = 0

      for(let x in data.popupHeaders){
        let curHeader = data.popupHeaders[x]
        if(curHeader.bool === true){
          if(col === 1){
            htmlString += `  <div class="column" style="width: 200px; text-align: left; padding-left: 20px;">`
          }
          if(col === 0){
            htmlString += `
                        <div class="row">
                          <div class="column" style="width: 200px; text-align: left; padding-left: 20px;">
                        `
          }

          const value = stackedClaims[y][curHeader.key];
          const outputValue = (value !== 'null' && value !== null && value !== 'undefined' && value !== undefined && value !== '' ? value : '--');

          htmlString += `<span>` + curHeader.title + `:<span></br><h3> ` + outputValue + `</h3>`
          htmlString += `</div>`
          if(col === 1){
            htmlString += `</div>`
            col = 0
          }else{
            col = 1
          }
        }
      }


      htmlString += `       </div>`
    }





    data.popup = new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(htmlString)
        .addTo(data.map)
  }
}

// const newEvent = entreos.subscribeToSchemaEvent('claims', function (e) {
//   vueApp.refresh()
// })

const clearMapPopups = () =>{
  const popups = document.getElementsByClassName("mapboxgl-popup");
  const popupsArray = Array.from(popups);
  popupsArray.forEach(function(el) {
    el.remove();
  });
}

onMounted(()=>{
  if(localStorage.getItem('version') === '5'){
    if(localStorage.getItem('headers') !== null){
      data.defaultHeaders = JSON.parse(localStorage.getItem('headers'))
    }
  }
  if(localStorage.getItem('versionClaimMap') === '2'){
    if(localStorage.getItem('headersClaimMap') !== null){
      data.popupHeaders = JSON.parse(localStorage.getItem('headersClaimMap'))
    }
  }


  document.getElementById('map').style.visibility = 'hidden';
  document.getElementById('map').style.height = '0px';

  mapboxgl.accessToken =
      'pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'

  data.map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [-83.9207, 35.9606],
    zoom: 6,
  })

  data.map.on('load', function () {
    data.map.loadImage(checklist, function (error, image) {
      if (error) throw error
      data.map.addImage('claim', image)
    })
    getData()
  })


  activeComponentStore.registerComponent(
      'SearchClaimsComponent',
      [
        'claims'
      ],
      getData
  );

})

const updateSortBy = (sortBy) => {
  if(JSON.stringify(sortBy) !== JSON.stringify(data.prevOptions?.sortBy)) {
    data.options.sortBy = sortBy;

    refresh({
      page: data.options.page,
      itemsPerPage: data.options.itemsPerPage,
      sortBy: sortBy
    });
  }
}

const updateItemsPerPage = (itemsPerPage) => {
  if(itemsPerPage !== data.prevOptions?.itemsPerPage){
    data.options.itemsPerPage = itemsPerPage;

    refresh({
      page: data.options.page,
      itemsPerPage: itemsPerPage,
      sortBy: data.options.sortBy
    });
  }
}

const updatePage = (page) => {
  if(page !== data.prevOptions?.page){
    data.options.page = page;

    refresh({
      page: page,
      itemsPerPage: data.options.itemsPerPage,
      sortBy: data.options.sortBy
    });
  }
}

const showMessaging = () =>{
  data.snackbar = true;
}

const addAllClaimsToMessages = () => {
   //console.log('add all claims to messages')
  let allClaimNums = [];
  data.claims.forEach(claim => {
    allClaimNums.push(claim.claimnumber)
  })
   //console.log(allClaimNums);
  // Combine arrays
  const combinedArray = allClaimNums.concat(data.messageSelections);

  // Filter the combined array to keep only the first occurrence of each value
  data.messageSelections = combinedArray.filter((item, index) => {
    return combinedArray.indexOf(item) === index;
  });
}

const submitMessage = async () => {
// console.log(data.dialogData);
    data.loading = true;
    let messageData = []
    data.dialogData.forEach((claim)=>{
       //console.log(claim.adjuster);
      if(claim.adjuster !== null && !(claim.id===null||claim.id===''||claim.id===undefined)){
        messageData.push(claim);
      }
    })
    await ApiWrapper.post('messaging', 'create-message-multiple-claims', {
      message: data.messageBody,
      private: data.isPrivate,
      claims: messageData
    })
        .then((response) => {
          data.loading = false
          data.isDisabled = false
          data.messageBody = ''
          data.isPrivate = false
          ToastUtil.successMsg('Created message');
        })
        .catch((e)=>{
          ToastUtil.error(e);
          data.loading = false
          data.isDisabled = false
        })

}

const updateTimeDue = async (single = false) => {
   //console.log('update time due one selection');
   //console.log(data.taskUpdateOneSelection);
  let claimIds = [];
  if(single){
    claimIds = data.taskUpdateOneSelection;
  }
  else{
    data.dialogData.forEach(claim=>{
      claimIds.push({claimid: claim.id})
    });
  }
  data.loading = true;
  data.isDisabled = true;
  await ApiWrapper.post('tasks', 'update-time-due-from-search-claims', {
    claims: claimIds,
    timedue: data.newTimeDue
  })
      .then((response) => {
         // console.log(response);
        data.loading = false
        data.isDisabled = false
        ToastUtil.successMsg('Updated Task Time Due');
        // update displayed task timer
        let dCopy = [];
        data.dialogData.forEach(claim=>{
              dCopy.push({
                id: claim.id,
                claimnumber: claim.claimnumber,
                adjuster: claim.adjuster,
                tasknames: claim.tasknames,
                taskexpire: claim.taskexpire
              })
        })
        response.results.successfulUpdates.forEach(claim=>{
          dCopy.forEach(c=>{
            if(c.id === claim.claimid){
              c.taskexpire = data.newTimeDue;
               console.log('update time for '+claim.claimId);
            }
          })
        })
         // console.log(dCopy);
        data.dialogData = dCopy;
        if(single){
          data.showTaskUpdateOneSelection=false;
        }
        else{
          data.showTaskUpdateAllSelections=false;
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
         // console.log(e);
        data.loading = false
        data.isDisabled = false
      })
}

watch(
    () => data.messageSelections,
    (newArray,oldArray) => {
      //get list of selected and deselected claim numbers
      let newSelectedArray = newArray.filter(claimnum => !oldArray.includes(claimnum));
      let deselectedArray = oldArray.filter(claimnum => !newArray.includes(claimnum));
      //capture selected data while we still have data from this search
      let selectedData = [];
      // get complete data for new selections
      newSelectedArray.forEach(newClaimNum=>{
        data.claims.forEach(claim=>{
          if(claim.claimnumber === newClaimNum){
            selectedData.push(
                {
                  id: claim.id,
                  claimnumber: claim.claimnumber,
                  adjuster: claim.adjuster,
                  tasknames: claim.tasknames,
                  taskexpire: claim.taskexpire
                }
            )
          }
        })
      })

      let cleanedData = [];
      //remove deselected claim data
      data.dialogData.forEach((claim)=>{
        if(!deselectedArray.includes(claim.claimnumber)){
          cleanedData.push(
              {
                id: claim.id,
                claimnumber: claim.claimnumber,
                adjuster: claim.adjuster,
                tasknames: claim.tasknames,
                taskexpire: claim.taskexpire
              }
          );
        }
      })

      //add selected claim data that is not yet captured (before another search removes detailed data)
      selectedData.forEach(claim=>{
        if(!cleanedData.some(x=>x.id===claim.id)){
          cleanedData.push(claim);
        }
      })

      data.dialogData = cleanedData;

    },
    { deep: true } // Must be deep to detect nested changes within the array/object
);

onUnmounted(() => {
  activeComponentStore.deregisterComponent('SearchClaimsComponent');
});

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" @keyup.enter="refresh">
      <v-toolbar flat color="white">
        <v-toolbar-title>Claims</v-toolbar-title>
        <div class="px-2">
          <v-btn size="small" variant="elevated" color="primary" @click="showMessaging" v-if="Permissions.checkPermissions(['messages.create-multiple'])">
            <v-icon size="small" class="mr-2">mdi-timeline-text-outline</v-icon> Messaging
          </v-btn>
        </div>
        <div class="px-2">
          <v-btn size="small" @click="refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })" variant="elevated" color="primary">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>

        <JsonCSV
            :data="data.claims"
            :fields="getHeaderFields()"
            name="Search Claims.csv"
            :labels="data.labels"
        >
          <v-btn size="small" variant="elevated" color="primary">
            <v-icon> mdi-file-download </v-icon>
          </v-btn>
        </JsonCSV>

        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>

        <v-divider class="mr-8" inset vertical></v-divider>

        <v-menu :close-on-content-click="false" offset-y class="px-7">
          <template v-slot:activator="{ on, props }">
            <v-btn size="small" variant="elevated" color="primary" dark v-bind="props" v-on="on">
              Select Headers
            </v-btn>
          </template>
          <v-list style="max-height: 750px"
                  class="overflow-y-auto">
            <v-list-item
                v-for="(item, index) in data.defaultHeaders"
                :key="index"
                density="compact"
            >
              <v-row>
                <v-col cols="2">
                  <v-checkbox @change="changeHeaders" v-model="item.bool"></v-checkbox>
                </v-col>
                <v-col cols="10" class="mt-4">
                  <v-list-item-title class="ml-1" color="#000000">{{item.title}}</v-list-item-title>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="ml-8">
          <v-btn
              v-if="!data.clustering"
              size="small"
              @click="data.clustering=true; refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })"
              variant="elevated"
              color="primary"
              dark
          >
            Cluster
          </v-btn>
          <v-btn
              v-else
              size="small"
              @click="data.clustering=false; refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })"
              variant="elevated"
              color="error"
              dark
          >
            Stop Clustering
          </v-btn>
        </div>
      </v-toolbar>

      <v-row class="px-5">
        <v-col cols="12" sm="6">
          <v-text-field v-model="data.claimnumber" label="Claim Number" @keyup.enter="refresh"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field v-model="data.insuredlastname" label="Insured Last Name" @keyup.enter="refresh"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="6">
          <v-text-field v-model="data.internalclaimnumber" label="Internal Claim Number"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field v-model="data.policynumber" label="Policy Number"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="6">
          <v-text-field v-model="data.lossstreet" label="Loss Street"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field v-model="data.insuredstreet" label="Insured Street"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="5">
          <v-text-field v-model="data.personname" label="Person Name (Any Part)"></v-text-field>
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field v-model="data.clientcontactname" label="Client Contact/Representative Name (Any Part)"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="5">
          <v-text-field v-model="data.claimantname" label="Claimant Name (Any Part)"></v-text-field>
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field v-model="data.reviewername" label="Reviewer Name (Any Part)"></v-text-field>
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field v-model="data.writername" label="Writer Name"></v-text-field>
        </v-col>

        <v-col cols="12" sm="2">
          <v-checkbox
              v-model="data.adjusterfirstcall"
              label="First Call?"
              hide-details
          ></v-checkbox>
          <v-checkbox
              v-model="data.adjusterpref"
              label="Pref?"
              hide-details
          ></v-checkbox>
          <v-checkbox
              v-model="data.adjustercatactive"
              label="CAT Active?"
              hide-details
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="6">
          <v-text-field v-model="data.statustimeremaining" label="Task Time Remaining(In Hours)"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field v-model="data.adjusterfirstname" label="Adjuster Name"></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <v-text-field v-model="data.catcode" label="Cat Code"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="6">
          <v-autocomplete
              :items="data.clients"
              v-model="data.insurancecompany"
              label="Insurance Company"
              clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.startdate"
              bottom
              :offset-y="data.offset1"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.startdate"
                  label="Start Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.startdate = DateUtil.formatDate(data.date); data.menu1 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.enddate"
              bottom
              :offset-y="data.offset2"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.enddate"
                  label="End Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.enddate = DateUtil.formatDate(data.date); data.menu2 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="6">
          <v-select
              :items="data.taskItems"
              v-model="data.currentstatus"
              label="Current Task"
              clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu3"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.lossstartdate"
              bottom
              :offset-y="data.offset3"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.lossstartdate"
                  label="Loss Start Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.lossstartdate = DateUtil.formatDate(data.date); data.menu3 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu4"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.lossenddate"
              bottom
              :offset-y="data.offset4"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.lossenddate"
                  label="Loss End Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.lossenddate = DateUtil.formatDate(data.date); data.menu4 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="3">
          <v-select
              :items="['Open', 'Closed', 'Both']"
              v-model="data.openclosedstatus"
              label="Open/Closed Status"
              clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-select
              :items="['Fire', 'Flood', 'Hail', 'Hurricane', 'Liability', 'Water', 'Wind', 'Other']"
              v-model="data.claimtype"
              label="Claim Type"
              clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu5"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.closedstartdate"
              bottom
              :offset-y="data.offset5"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.closedstartdate"
                  label="Closed Start Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.closedstartdate = DateUtil.formatDate(data.date); data.menu5 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu6"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.closedenddate"
              bottom
              :offset-y="data.offset6"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.closedenddate"
                  label="Closed End Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.closedenddate = DateUtil.formatDate(data.date); data.menu6 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="6"></v-col>

        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu7"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.originalclosedstartdate"
              bottom
              :offset-y="data.offset7"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.originalclosedstartdate"
                  label="Original Closed Start Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.originalclosedstartdate = DateUtil.formatDate(data.date); data.menu7 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu8"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.originalclosedenddate"
              bottom
              :offset-y="data.offset8"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.originalclosedenddate"
                  label="Original Closed End Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.originalclosedenddate = DateUtil.formatDate(data.date); data.menu8 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="6"></v-col>

        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu9"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.receivedstartdate"
              bottom
              :offset-y="data.offset9"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.receivedstartdate"
                  label="Date Received Start Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.receivedstartdate = DateUtil.formatDate(data.date); data.menu9 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="3">
          <v-menu
              v-model="data.menu10"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.receivedenddate"
              bottom
              :offset-y="data.offset10"
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.receivedenddate"
                  label="Date Received End Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.receivedenddate = DateUtil.formatDate(data.date); data.menu10 = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col cols="12" sm="6">
          <v-select
              :items="data.stateItems"
              v-model="data.state"
              label="State"
              clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-select
              :items="['Greater Than', 'Less Than', 'Equal To']"
              v-model="data.estimatedlosscompare"
              label="Estimated Loss Amount"
              clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field v-model="data.estimatedloss" label="Estimated Amount"></v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-5 mb-3" v-if="data.snackbar && data.claims.length > 1">
        <v-col align="right">
          <v-btn @click="refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })" color="primary" :loading="data.dataLoading">
            Search Claims
          </v-btn>
        </v-col>
        <v-col align="right">
          <v-btn
              v-if="Permissions.checkPermissions(['messages.create-multiple'])"
              @click="addAllClaimsToMessages()"
              color="info"
              :loading="data.dataLoading"
              prepend-icon="mdi-plus"
          >
            Add All Claims to Messages
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="px-5" v-else>
        <v-col align="center">
          <v-btn @click="refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
                })" 
                 color="primary" 
                 :loading="data.dataLoading"
                 ref="searchBtnRef"
          >
            Search Claims
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table-server
          :search='data.searchRefresh'
          :headers="data.headers"
          :items="data.claims"
          :items-length="data.totalClaims"
          :loading="data.dataLoading"
          class="elevation-1"
          loading-text="Loading... Please wait"
          :items-per-page-options="[5, 10, 15, 30, 50, 100, 500, 1000, 2000, 3000]"

          :page="data.options.page"
          @update:page="updatePage"
          :items-per-page="data.options.itemsPerPage"
          @update:itemsPerPage="updateItemsPerPage"
          :sortBy="data.options.sortBy"
          @update:sortBy="updateSortBy"
      >
          <template v-slot:[`item.id`]="{ item }">
            <RouterLink :to="`/claim/${item.id}`">
              {{item.claimnumber}}
            </RouterLink>
          </template>
          <template v-slot:[`item.claimnumber`]="{ item }">
            <v-row v-if="data.snackbar">
              <v-col cols="2">
                <v-checkbox
                    v-if="data.snackbar"
                    v-model="data.messageSelections"
                    :value="item.claimnumber"
                    class="mt-0"
                    density="compact"
                    hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="10">
                <RouterLink :to="`/claim/${item.id}`">
                  {{item.claimnumber}}
                </RouterLink>
              </v-col>
            </v-row>
            <RouterLink :to="`/claim/${item.id}`" v-else>
              {{item.claimnumber}}
            </RouterLink>
          </template>
          <template v-slot:[`item.isclosed`]="{ item }">
            <span v-if="!item.isclosed">Open</span>
            <span v-else>Closed</span>
          </template>
          <template v-slot:[`item.recentcompletetime`]="{ item }">
            {{ DateUtil.formatTimestamp(item.recentcompletetime, 'datetime') }}
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <RouterLink :to="`/client/${item.clientid}`">
              {{ item.name }}
            </RouterLink>
          </template>
          <template v-slot:[`item.lossdate`]="{ item }">
            {{ DateUtil.formatDate(item.lossdate) }}
          </template>
          <template v-slot:[`item.datereceived`]="{ item }">
            {{ DateUtil.formatDate(item.datereceived) }}
          </template>
          <template v-slot:[`item.taskexpire`]="{ item }">
            {{ DateUtil.formatTimestamp(item.taskexpire, 'datetime') }}
          </template>
          <template v-slot:[`item.apptset`]="{ item }">
            {{ DateUtil.formatTimestamp(item.apptset, 'datetime') }}
          </template>
          <template v-slot:[`item.datecontacted`]="{ item }">
            {{ DateUtil.formatDate(item.datecontacted) }}
          </template>
          <template v-slot:[`item.inspectionscheduled`]="{ item }">
            {{ DateUtil.formatDate(item.inspectionscheduled) }}
          </template>
          <template v-slot:[`item.inspectioncompleted`]="{ item }">
            {{ DateUtil.formatDate(item.inspectioncompleted) }}
          </template>
          <template v-slot:[`item.reviewcompleted`]="{ item }">
            {{ DateUtil.formatDate(item.reviewcompleted) }}
          </template>
          <template v-slot:[`item.dateclosed`]="{ item }">
            {{ DateUtil.formatDate(item.dateclosed) }}
          </template>
          <template v-slot:[`item.originaldateclosed`]="{ item }">
            {{ DateUtil.formatDate(item.originaldateclosed) }}
          </template>
          <template v-slot:[`item.datereviewerassigned`]="{ item }">
            {{ DateUtil.formatDate(item.datereviewerassigned) }}
          </template>
      </v-data-table-server>
      <v-row class="px-10 mt-5" align="center">
        <v-col align="center" cols='12' sm='8'>
          <v-text-field
              @change="searchMap"
              label="Search Map"
              type="text"
              v-model="data.searchRequest"
              class="ml-4"
              v-if="data.showMap"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <div class="mx-2">
            <v-menu                 v-if="data.showMap"              :close-on-content-click="false" offset-y >
              <template v-slot:activator="{ on, props }">
                <v-btn color="primary" dark v-bind="props" v-on="on">
                  Popup Info.
                </v-btn>
              </template>
              <v-list style="max-height: 750px"
                      class="overflow-y-auto">
                <v-list-item
                    v-for="(item, index) in data.popupHeaders"
                    :key="index"
                >
                  <v-checkbox @update:modelValue="item.bool=$event; mapCreateUnclusteredPointPopup({})" v-model="item.bool" :label="item.title"></v-checkbox>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
        <v-col cols='12' sm='2'>
          <v-btn
              v-if="data.showMap"
              class="grey lighten-2 ml-2"
              size="x-small"
              @click="data.showMap = false; hideMap(false);"
          >
            <v-icon left size="x-small">mdi-window-close</v-icon>
            Stop Showing Map
          </v-btn>
          <v-btn
              v-else
              class="grey lighten-2 ml-2"
              size="x-small"
              variant="elevated"
              @click="data.showMap = true; hideMap(true);"
          >
            <v-icon left size="x-small">mdi-plus</v-icon>
            Show Map
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col align="center">
          <div id="map"></div>
        </v-col>
      </v-row>
    </v-card>
    <v-snackbar
        v-if="Permissions.checkPermissions(['messages.create-multiple'])"
        v-model="data.snackbar"
        location="bottom right"
        :timeout="-1"
        color="white"
        elevation="10"
    >
      <v-chip>
        Claims selected: {{data.messageSelections.length}}
      </v-chip>

      <template v-slot:actions>
        <v-btn
            :disabled="data.messageSelections.length===0"
            size="small"
            color="primary"
            variant="elevated"
            class="mr-3"
            @click="data.messageDialog = true;"
        >
          <v-icon size="16">mdi-pen-plus</v-icon> Write Message
        </v-btn>
        <v-btn
            size="small"
            color="error"
            variant="elevated"
            @click="data.snackbar = false"
        >
          <v-icon size="16">mdi-close</v-icon> Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
        v-if="Permissions.checkPermissions(['messages.create-multiple'])"
        v-model="data.messageDialog"
        width="auto"
        max-width="750">
      <v-card
          max-width="725"
          prepend-icon="mdi-timeline-plus-outline"
          title="Message Multiple Claims"
      >
        <v-card-text>
          <v-card-actions class="pb-0">
            <v-textarea
                class="pt-2"
                prepend-inner-icon="mdi-message"
                v-model="data.messageBody"
                clearable
                @click:clear="updateMessageBody()"
                filled
                auto-grow
                label="Enter message"
                hint="Max 70 characters"
                counter
                density="compact"
            ></v-textarea>
          </v-card-actions>
          <v-card-actions class="pt-0">
            <v-checkbox
                density="compact"
                v-model="data.isPrivate"
                label="Private?"
                class="pl-4"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn
                size="small"
                variant="elevated"
                color="primary"
                class="white--text"
                v-if="Permissions.checkPermissions(['messages.create-multiple'])"
                :disabled="data.isDisabled === true || data.messageBody === '' || data.messageBody === null || data.recipients?.name?.length === 0"
                @click="submitMessage(); data.isDisabled = true"
            >Send Message</v-btn>
          </v-card-actions>
          <v-data-table
              :headers="[
                  {title: 'Claim Number',key: 'claimnumber',align:'start'},
                  {title: 'Adjuster',key: 'adjuster',align:'start'},
                  {title: 'In Task',key: 'tasknames',align:'start'},
                  {title: 'Task Expire Date',key: 'taskexpire',align:'start'}
                  ]"
              :items="data.dialogData"
              class="elevation-1"
          >
            <template v-slot:[`item.claimnumber`]="{ item }">
              <v-row>
                <v-col cols="2">
                  <v-checkbox
                      v-model="data.messageSelections"
                      :value="item.claimnumber"
                      class="mt-0"
                      density="compact"
                      hide-details
                  ></v-checkbox>
                </v-col>
                <v-col cols="10">
                  <RouterLink :to="`/claim/${item.id}`">
                    {{item.claimnumber}}
                  </RouterLink>
                </v-col>
              </v-row>
            </template>
            <template v-slot:[`item.adjuster`]="{ item }">
              <span v-if="item.adjuster === null">
                <v-alert
                    type="error"
                    text="No Adjuster, message will not be sent."
                    density="compact"
                    :icon="false"
                    variant="outlined"
                ></v-alert>
              </span>
              <span v-else>
                {{item.adjuster}}
              </span>
            </template>
            <template v-slot:[`item.tasknames`]="{ item }">
              {{item.tasknames}}
            </template>
            <template v-slot:[`item.taskexpire`]="{ item }">
              <task-timedue
                  :timedue="item.taskexpire"
                  v-on:click="
                  data.showTaskUpdateOneSelection = true;
                  data.showTaskUpdateAllSelections = false;
                  data.taskUpdateOneSelection = [{claimid:item.id,claimnumber:item.claimnumber}]"
              >
              </task-timedue>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container v-if="data.showTaskUpdateOneSelection && !data.showTaskUpdateAllSelections">
            <v-card>
              <v-card-title>
                Update Task Time Due for Claim # {{data.taskUpdateOneSelection[0].claimnumber}}
              </v-card-title>
              <v-card-text>
                <flat-pickr
                    class="form-control"
                    v-model="data.newTimeDue"
                    :config="data.config.flatpickr"
                >
                </flat-pickr>
                <v-alert
                    text="For a selected date beyond today, the time due will be recorded as 12:00 noon Eastern Time for that day."
                    color="secondary"
                    border="start"
                    border-color="info"
                    variant="outlined"
                ></v-alert>
              </v-card-text>
            </v-card>
            <v-card-actions>
              <v-card-actions>
                <v-btn
                    size="small"
                    class="mr-2"
                    color="primary"
                    variant="elevated"
                    prepend-icon="mdi-timer-plus"
                    :disabled="data.loading"
                    @click="updateTimeDue(true)"
                >
                  Update
                </v-btn>
                <v-btn
                    size="small"
                    variant="elevated"
                    color="error"
                    :disabled="data.loading"
                    @click="data.showTaskUpdateOneSelection = false"
                >
                  Cancel
                </v-btn>
                <!--                v-if="Permissions.checkPermissions(['tasks.update-time-due'])"-->

              </v-card-actions>
            </v-card-actions>
          </v-container>
          <v-container v-if="data.showTaskUpdateAllSelections && !data.showTaskUpdateOneSelection">
            <v-card>
              <v-card-title>
                Update Task Time Due for ALL Selected Claims
              </v-card-title>
              <v-card-text>
                <flat-pickr
                    class="form-control"
                    v-model="data.newTimeDue"
                    :config="data.config.flatpickr"
                >
                </flat-pickr>
                <v-alert
                    text="For a selected date beyond today, the time due will be recorded as 12:00 noon Eastern Time for that day."
                    color="secondary"
                    border="start"
                    border-color="info"
                    variant="outlined"
                ></v-alert>
              </v-card-text>
              <v-card-actions>
                <v-btn
                    size="small"
                    class="primary"
                    color="primary"
                    variant="elevated"
                    prepend-icon="mdi-timer-plus"
                    :disabled="data.loading"
                    @click="updateTimeDue()"
                >
                  Update
                </v-btn>
                <v-btn
                    size="small"
                    variant="elevated"
                    color="error"
                    :disabled="data.loading"
                    @click="data.showTaskUpdateAllSelections = false"
                >
                  Cancel
                </v-btn>
                <!--                v-if="Permissions.checkPermissions(['tasks.update-time-due'])"-->
              </v-card-actions>
            </v-card>
          </v-container>
        </v-card-text>
        <template v-slot:actions>
          <v-btn
              v-if="!data.showTaskUpdateOneSelection"
              size="small"
              color="warning"
              variant="elevated"
              prepend-icon="mdi-timer-edit"
              @click="data.showTaskUpdateAllSelections = true"
          >
            Extend All Task Times
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              size="small"
              color="error"
              variant="elevated"
              @click="data.messageDialog = false"
          >
            <v-icon size="16">mdi-close</v-icon> Close
          </v-btn>
        </template>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<style scoped>
input.flatpickr-input {
  display: none;
}
</style>